// extracted by mini-css-extract-plugin
module.exports = {"PhotoPane":"styles-module--PhotoPane--V41dx"};